import React, { useEffect, useState } from 'react';
import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  FormHelperText,
} from '@material-ui/core';
import axios from 'axios';
import { useApi, identityApiRef, discoveryApiRef } from '@backstage/core-plugin-api';

export const SelectAdoProjects = (
  props: FieldExtensionComponentProps<string>,
) => {
  const { onChange, formData, required, rawErrors, schema } = props;
  const [options, setOptions] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);

  const identityApi = useApi(identityApiRef);
  const discoveryApi = useApi(discoveryApiRef);

  useEffect(() => {
    async function fetchProjects() {
      try {
        const baseUrl = await discoveryApi.getBaseUrl('scaffolder');
        const { token } = await identityApi.getCredentials();
        const profile = await identityApi.getProfileInfo();

        const res = await axios.post(
          `${baseUrl}/ado/user/projects`,
          {
            username: profile.email,
            forceRefresh: false,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          },
        );

        if (Array.isArray(res.data.projects)) {
          setOptions(res.data.projects);
        } else {
          console.warn('Unexpected response format from /ado/user/projects');
        }
      } catch (e) {
        console.error('Error fetching ADO projects:', e);
      } finally {
        setLoading(false);
      }
    }

    fetchProjects();
  }, [identityApi, discoveryApi]);

  const labelId = 'select-ado-projects-label';

  return (
    <FormControl
      fullWidth
      required={required}
      error={rawErrors?.length > 0}
      variant="outlined"
    >
      <InputLabel id={labelId}>{schema.title}</InputLabel>
      {loading ? (
        <CircularProgress size={24} />
      ) : (
        <>
          <Select
            labelId={labelId}
            value={formData || ''}
            onChange={e => onChange(e.target.value as string)}
            label={schema.title}
          >
            {options.map(opt => (
              <MenuItem key={opt} value={opt}>
                {opt}
              </MenuItem>
            ))}
          </Select>
          {rawErrors && rawErrors.length > 0 && (
            <FormHelperText>{rawErrors.join(', ')}</FormHelperText>
          )}
        </>
      )}
    </FormControl>
  );
};
